import {
    DOCUMENTATION_CARD_CONTENT_ID,
    COMMUNITY_CARD_CONTENT_ID,
    STATUS_CARD_CONTENT_ID,
    FEEDBACK_CARD_CONTENT_ID,
    MARKETPLACE_CARD_CONTENT_ID,
    BILLING_CARD_CONTENT_ID,
    KNOWLEDGEBASE_CARD_CONTENT_ID
} from './constants';

const defaultCardHandler = ({ card, link, entry, index }) => {
    card.buttonLink = link;
    // remove link if not defined
    if (!card.buttonLink) {
        entry.resourceCards.cards.splice(index, 1);
    }
};

const buildLinks = (entry, index) => {
    const card = entry.resourceCards.cards[index];

    switch (card.id) {
        case DOCUMENTATION_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.documentationLink,
                entry,
                index
            });
            break;
        case COMMUNITY_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.communityLink,
                entry,
                index
            });
            break;
        case STATUS_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.statusLink,
                entry,
                index
            });
            break;
        case FEEDBACK_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.feedbackLink,
                entry,
                index
            });
            break;
        case MARKETPLACE_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.marketplaceLink,
                entry,
                index
            });
            break;
        case BILLING_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.billingLicensingLink,
                entry,
                index
            });
            break;
        case KNOWLEDGEBASE_CARD_CONTENT_ID:
            defaultCardHandler({
                card,
                link: entry.knowledgeBaseLink,
                entry,
                index
            });
            break;
        default:
            return (card.buttonLink = null);
    }
};

export const setDefaultCardLinks = entry => {
    // don't do anything if there aren't any resource cards defined
    if (!entry.resourceCards.cards.length) {
        return;
    }

    // iterate through each defaultResourceCard replacing the default links with
    // links from the productLandingPage, if defined.
    const length = entry.resourceCards.cards.length;

    for (let index = length - 1; index >= 0; index--) {
        buildLinks(entry, index);
    }
};
